var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9479 9.95006L14.9979 8.00006V14.5871C14.9979 15.4771 13.9209 15.9241 13.2909 15.2941L11.9959 14.0001C11.4959 13.5001 10.2949 13.2001 9.49395 14.0001C8.69395 14.8001 8.99395 16.0001 9.49395 16.5001L13.0969 20.9001C13.3785 21.2441 13.7329 21.5212 14.1347 21.7114C14.5364 21.9017 14.9754 22.0003 15.4199 22.0001H17.9999C18.2652 22.0001 18.5195 21.8947 18.7071 21.7072C18.8946 21.5196 18.9999 21.2653 18.9999 21.0001V14.9001C18.9998 13.9806 18.8184 13.0703 18.4663 12.2209C18.1143 11.3716 17.5983 10.6 16.9479 9.95006Z",
    fill: "#028789",
    stroke: "#028789",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.00006H13C13.5304 2.00006 14.0391 2.21077 14.4142 2.58585C14.7893 2.96092 15 3.46963 15 4.00006V6.00006M11 2.00006C11 3.33306 11.8 6.00006 15 6.00006M11 2.00006H9M15 6.00006V12.0001M5 12.0001V6.00006M9 2.00006H7C6.46957 2.00006 5.96086 2.21077 5.58579 2.58585C5.21071 2.96092 5 3.46963 5 4.00006V6.00006M9 2.00006C9 3.33306 8.2 6.00006 5 6.00006M5 12.0001V14.0001C5 14.5305 5.21071 15.0392 5.58579 15.4143C5.96086 15.7893 6.46957 16.0001 7 16.0001H9C9 14.6671 8.2 12.0001 5 12.0001Z",
    stroke: "#028789",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.00006C9 9.55235 9.44772 10.0001 10 10.0001C10.5523 10.0001 11 9.55235 11 9.00006C11 8.44778 10.5523 8.00006 10 8.00006C9.44772 8.00006 9 8.44778 9 9.00006Z",
    stroke: "#028789",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoans);
export default __webpack_public_path__ + "static/media/loans.39d51b8878c0a93bd0becde29660cabb.svg";
export { ForwardRef as ReactComponent };